import React from "react";
import PicturesShell from "../PicturesShell";
import "../../styles/pictures-status-screens.css";
import "./style.css";

export default function GuidedCompleteScreen({ onExit, photoCount = 16 }) {
  return (
    <PicturesShell
      mainClassName="pi-pictures-main--center pi-pictures-main--status"
      badge="Photos complete"
      showFooter={false}
    >
      <div
        className="pi-pictures-status-card pi-pictures-status-card--premium pi-guided-complete"
        role="status"
      >
        <span className="pi-pictures-label">All set</span>
        <div className="pi-guided-complete__icon" aria-hidden>
          ✓
        </div>
        <h1>All {photoCount} photos uploaded</h1>
        <p>
          Your guided vehicle photos are saved. Tap Exit to review them or continue.
        </p>
        <div className="pi-guided-complete__actions">
          <button
            type="button"
            className="pi-guided-complete__exit"
            onClick={onExit}
          >
            Exit
          </button>
        </div>
      </div>
    </PicturesShell>
  );
}
